import {
    ArrayExpr,
    BinaryExpr,
    CellReference,
    ComparisonExpr,
    ConcatExpr,
    FormulaValueExpression,
    FrameCalculatedColumnExpr,
    FrameColumnReference,
    IdentifierLiteral,
    IntersectionReference,
    InvokeFunctionExpr,
    LazyFormulaExpression,
    ListReference,
    LiveFormulaExpression,
    NegateExpr,
    ParenExpr,
    PercentExpr,
    RangeReference,
    UnionReference,
    ValueLiteral
} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaASTNodes';
import {IFormulaNode} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaDefinitions';

export type ShouldContinueTraversal = boolean;

export interface IFormulaVisitorAsync
{
    arrayExpr(array:ArrayExpr):Promise<any>;

    identifierLiteral(identifier:IdentifierLiteral):Promise<any>;

    valueLiteral(value:ValueLiteral):Promise<any>;

    cellReference(cellRef:CellReference):Promise<any>;

    rangeReference(range:RangeReference):Promise<any>;

    unionReference(union:UnionReference):Promise<any>;

    listReference(list:ListReference):Promise<any>;

    intersectionReference(intersection:IntersectionReference):Promise<any>;

    frameColumnReference(frameColumn:FrameColumnReference):Promise<any>;

    frameCalculatedColumnExpr(frameCalculatedColumn:FrameCalculatedColumnExpr):Promise<any>;

    preFormulaExpr(formulaExpr:FormulaValueExpression):Promise<any>;

    preLazyExpr(lazyExpr:LazyFormulaExpression):Promise<any>;

    preLiveExpr(liveExpr:LiveFormulaExpression):Promise<any>;

    preInvokeFunction(invokeFuncExpr:InvokeFunctionExpr):Promise<any>;

    preInvokeFunctionParameter(invokeFuncExpr:InvokeFunctionExpr, param:IFormulaNode, paramIndex:number);

    invokeFunctionParameter(invokeFuncExpr:InvokeFunctionExpr, param:IFormulaNode, paramIndex:number):Promise<any>;

    postInvokeFunctionParameter(invokeFuncExpr:InvokeFunctionExpr, param:IFormulaNode, paramIndex:number);

    invokeFunction(invokeFuncExpr:InvokeFunctionExpr):Promise<any>;

    postInvokeFunction(invokeFuncExpr:InvokeFunctionExpr):void;

    preParenExpr(parenExpr:ParenExpr);

    postParenExpr(parenExpr:ParenExpr);

    formulaExpr(formulaExpr:FormulaValueExpression):Promise<any>;

    lazyExpr(lazyExpr:LazyFormulaExpression):Promise<any>;

    liveExpr(liveExpr:LiveFormulaExpression):Promise<any>;

    percentExpr(percentExpr:PercentExpr):Promise<any>;

    negateExpr(negateExpr:NegateExpr):Promise<any>;

    parenExpr(parenExpr:ParenExpr):Promise<any>;

    binaryExpr(binaryExpr:BinaryExpr):Promise<any>;

    concatExpr(concatExpr:ConcatExpr):Promise<any>;

    comparisonExpr(comparisonExpr:ComparisonExpr):Promise<any>;

    arrayExpr(array:ArrayExpr):Promise<any>;
}

export interface IFormulaVisitor
{
    identifierLiteral(identifier:IdentifierLiteral);

    valueLiteral(value:ValueLiteral);

    cellReference(cellRef:CellReference);

    rangeReference(range:RangeReference);

    unionReference(union:UnionReference);

    listReference(list:ListReference);

    intersectionReference(intersection:IntersectionReference);

    frameColumnReference(frameColumn:FrameColumnReference);

    frameCalculatedColumnExpr(frameCalculatedColumn:FrameCalculatedColumnExpr);

    preInvokeFunction(invokeFuncExpr:InvokeFunctionExpr);

    postInvokeFunction(invokeFuncExpr:InvokeFunctionExpr);

    preFormulaExpr(formulaExpr:FormulaValueExpression);

    postFormulaExpr(formulaExpr:FormulaValueExpression);

    preLazyExpr(lazyExpr:LazyFormulaExpression);

    postLazyExpr(lazyExpr:LazyFormulaExpression);

    preLiveExpr(liveExpr:LiveFormulaExpression);

    postLiveExpr(liveExpr:LiveFormulaExpression);

    prePercentExpr(percentExpr:PercentExpr);

    postPercentExpr(percentExpr:PercentExpr);

    preNegateExpr(negateExpr:NegateExpr);

    postNegateExpr(negateExpr:NegateExpr);

    preParenExpr(parenExpr:ParenExpr);

    postParenExpr(parenExpr:ParenExpr);

    preBinaryExpr(binaryExpr:BinaryExpr);

    postBinaryExpr(binaryExpr:BinaryExpr);

    preConcatExpr(concatExpr:ConcatExpr);

    postConcatExpr(concatExpr:ConcatExpr);

    preComparisonExpr(comparisonExpr:ComparisonExpr);

    postComparisonExpr(comparisonExpr:ComparisonExpr);

    preArrayExpr(array:ArrayExpr);

    postArrayExpr(array:ArrayExpr);
}

export class BaseFormulaVisitorAsync implements IFormulaVisitorAsync
{
    postParenExpr(parenExpr:ParenExpr)
    {
        return;
    }

    preParenExpr(parenExpr:ParenExpr)
    {
        return;
    }

    identifierLiteral(identifier:IdentifierLiteral):Promise<any>
    {
        return;
    }

    binaryExpr(binaryExpr:BinaryExpr):Promise<any>
    {
        return;
    }

    cellReference(cellRef:CellReference):Promise<any>
    {
        return;
    }

    comparisonExpr(comparisonExpr:ComparisonExpr):Promise<any>
    {
        return;
    }

    concatExpr(concatExpr:ConcatExpr):Promise<any>
    {
        return;
    }

    formulaExpr(formulaExpr:FormulaValueExpression):Promise<any>
    {
        return;
    }

    preFormulaExpr(formulaExpr:FormulaValueExpression):Promise<any>
    {
        return;
    }

    preLazyExpr(lazyExpr:LazyFormulaExpression):Promise<any>
    {
        return;
    }

    lazyExpr(lazyExpr:LazyFormulaExpression):Promise<any>
    {
        return;
    }

    preLiveExpr(liveExpr:LiveFormulaExpression):Promise<any>
    {
        return;
    }

    liveExpr(liveExpr:LiveFormulaExpression):Promise<any>
    {
        return;
    }

    negateExpr(negateExpr:NegateExpr):Promise<any>
    {
        return;
    }

    parenExpr(parenExpr:ParenExpr):Promise<any>
    {
        return;
    }

    percentExpr(percentExpr:PercentExpr):Promise<any>
    {
        return;
    }

    preInvokeFunction(invokeFuncExpr:InvokeFunctionExpr):Promise<any>
    {
        return;
    }

    invokeFunction(invokeFuncExpr:InvokeFunctionExpr):Promise<any>
    {
        return;
    }

    postInvokeFunction(invokeFuncExpr:InvokeFunctionExpr):void
    {
        return;
    }

    preInvokeFunctionParameter(invokeFuncExpr:InvokeFunctionExpr, param:IFormulaNode, paramIndex:number)
    {
        return;
    }

    invokeFunctionParameter(invokeFuncExpr:InvokeFunctionExpr, param:IFormulaNode, paramIndex:number):Promise<any>
    {
        return;
    }

    postInvokeFunctionParameter(invokeFuncExpr:InvokeFunctionExpr, param:IFormulaNode, paramIndex:number)
    {
        return;
    }

    rangeReference(range:RangeReference):Promise<any>
    {
        return;
    }

    intersectionReference(range:IntersectionReference):Promise<any>
    {
        return;
    }

    unionReference(range:UnionReference):Promise<any>
    {
        return;
    }

    listReference(list:ListReference):Promise<any>
    {
        return;
    }

    valueLiteral(value:ValueLiteral):Promise<any>
    {
        return;
    }

    arrayExpr(array:ArrayExpr):Promise<any>
    {
        return;
    }

    frameCalculatedColumnExpr(frameCalculatedColumn:FrameCalculatedColumnExpr):Promise<any>
    {
        return;
    }

    frameColumnReference(frameColumn:FrameColumnReference):Promise<any>
    {
        return;
    }
}

export class BaseFormulaVisitor implements IFormulaVisitor
{
    frameCalculatedColumnExpr(frameCalculatedColumn:FrameCalculatedColumnExpr)
    {
    }

    frameColumnReference(frameColumn:FrameColumnReference)
    {
    }

    identifierLiteral(value:IdentifierLiteral)
    {
    }

    cellReference(cellRef:CellReference)
    {
    }

    postBinaryExpr(binaryExpr:BinaryExpr)
    {
    }

    postComparisonExpr(comparisonExpr:ComparisonExpr)
    {
    }

    postConcatExpr(concatExpr:ConcatExpr)
    {
    }

    postInvokeFunction(invokeFuncExpr:InvokeFunctionExpr)
    {
    }

    postFormulaExpr(formulaExpr:FormulaValueExpression)
    {
    }

    preFormulaExpr(formulaExpr:FormulaValueExpression)
    {
    }

    postLazyExpr(lazyExpr:LazyFormulaExpression)
    {
    }

    preLazyExpr(lazyExpr:LazyFormulaExpression)
    {
    }

    postLiveExpr(liveExpr:LiveFormulaExpression)
    {
    }

    preLiveExpr(liveExpr:LiveFormulaExpression)
    {
    }

    postNegateExpr(negateExpr:NegateExpr)
    {
    }

    postPercentExpr(percentExpr:PercentExpr)
    {
    }

    preBinaryExpr(binaryExpr:BinaryExpr)
    {
    }

    preComparisonExpr(comparisonExpr:ComparisonExpr)
    {
    }

    preConcatExpr(concatExpr:ConcatExpr)
    {
    }

    preInvokeFunction(invokeFuncExpr:InvokeFunctionExpr)
    {
    }

    preNegateExpr(negateExpr:NegateExpr)
    {
    }

    prePercentExpr(percentExpr:PercentExpr)
    {
    }

    rangeReference(range:RangeReference)
    {
    }

    intersectionReference(intersection:IntersectionReference)
    {
    }

    unionReference(union:UnionReference)
    {
    }

    listReference(list:ListReference)
    {
    }

    valueLiteral(value:ValueLiteral)
    {
    }

    postArrayExpr(array:ArrayExpr)
    {
    }

    preArrayExpr(array:ArrayExpr)
    {
    }

    postParenExpr(parenExpr:ParenExpr)
    {
    }

    preParenExpr(parenExpr:ParenExpr)
    {
    }
}
